export async function downloadOnClick(
  contenUrl: string, 
  fileName: string,
  openFileInNewTab: boolean = false
) {
  const a = document.createElement("a")
  a.style.display = "none"
  if (openFileInNewTab) {
    a.href = contenUrl
    a.target = "_blank"
    document.body.appendChild(a)
    a.click()
    a.remove()
  } else {
    const fileData = await fetch(contenUrl)
    const blob = await fileData.blob()

    const isValid = !!blob && !!fileName
    if (!isValid) return

    const url = URL.createObjectURL(blob)
    
    a.href = url
    a.download = fileName

    document.body.appendChild(a)
    a.click()
    a.remove()
    URL.revokeObjectURL(url)
  }
}